import { useState } from "react";

export default function ContactForm() {
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);

        const form = e.currentTarget;
        const formData = new FormData(form);

        const res = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData,
        });

        const data = await res.json();

        setLoading(false);

        if (data.success) {
            setSuccess(true);
            form.reset();
        }
    };

    return (
        <section id="contactform" className="py-24 bg-[--color-bg-main] relative">
            <div className="max-w-3xl mx-auto px-6">

                <p className="text-xs tracking-widest text-gray-400 mb-4 text-center">
                    KONTAKT
                </p>

                <h2 className="text-4xl font-serif mb-16 text-center">
                    Schreiben Sie uns
                </h2>

                <form onSubmit={handleSubmit} className="space-y-10">

                    {/* REQUIRED */}
                    <input
                        type="hidden"
                        name="access_key"
                        value="30ea9656-70f0-4679-9fed-b117a58be2ed"
                    />

                    {/* Spam protection */}
                    <input
                        type="checkbox"
                        name="botcheck"
                        className="hidden"
                        style={{ display: "none" }}
                    />

                    {/* NAME */}
                    <div>
                        <label className="block text-sm text-gray-500 mb-2">
                            Ihr Name
                        </label>
                        <input
                            name="name"
                            required
                            className="w-full bg-transparent border-b border-gray-300 focus:border-black outline-none py-2"
                        />
                    </div>

                    {/* EMAIL */}
                    <div>
                        <label className="block text-sm text-gray-500 mb-2">
                            Ihre E-Mail
                        </label>
                        <input
                            type="email"
                            name="email"
                            required
                            className="w-full bg-transparent border-b border-gray-300 focus:border-black outline-none py-2"
                        />
                    </div>

                    {/* PHONE */}
                    <div>
                        <label className="block text-sm text-gray-500 mb-2">
                            Ihr Telefon
                        </label>
                        <input
                            name="phone"
                            className="w-full bg-transparent border-b border-gray-300 focus:border-black outline-none py-2"
                        />
                    </div>

                    {/* MESSAGE */}
                    <div>
                        <label className="block text-sm text-gray-500 mb-2">
                            Ihre Nachricht
                        </label>
                        <textarea
                            name="message"
                            rows={4}
                            required
                            className="w-full bg-transparent border-b border-gray-300 focus:border-black outline-none py-2 resize-none"
                        />
                    </div>

                    {/* BUTTON */}
                    <div className="pt-10 text-center">
                        <button
                            type="submit"
                            disabled={loading}
                            className="inline-block text-sm tracking-widest uppercase border border-black px-10 py-4 hover:bg-black hover:text-white transition disabled:opacity-40"
                        >
                            {loading ? "Senden…" : "Absenden"}
                        </button>
                    </div>
                </form>
            </div>

            {/* SUCCESS POPUP */}
            {success && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white px-12 py-10 rounded-sm text-center max-w-md">
                        <h3 className="text-2xl font-serif mb-4">
                            Vielen Dank
                        </h3>
                        <p className="text-gray-600 mb-8">
                            Ihre Nachricht wurde erfolgreich gesendet.
                        </p>
                        <button
                            onClick={() => setSuccess(false)}
                            className="text-sm tracking-widest uppercase border border-black px-8 py-3 hover:bg-black hover:text-white transition"
                        >
                            Schließen
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
}
